module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b25qj"))).then(() => parcelRequire('hEqeo'));